var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 24.1667H27.4998C27.9601 24.1667 28.3332 24.5398 28.3332 25.0001C28.3332 25.4274 28.0115 25.7797 27.597 25.8278L27.4998 25.8334H12.4998C12.0396 25.8334 11.6665 25.4603 11.6665 25.0001C11.6665 24.5727 11.9882 24.2205 12.4027 24.1724L12.4998 24.1667H27.4998H12.4998ZM12.4997 19.1667L27.4997 19.1649C27.96 19.1649 28.3332 19.5379 28.3332 19.9982C28.3332 20.4255 28.0116 20.7778 27.5971 20.826L27.4999 20.8316L12.4999 20.8334C12.0397 20.8335 11.6665 20.4604 11.6665 20.0002C11.6665 19.5728 11.9881 19.2206 12.4026 19.1724L12.4997 19.1667L27.4997 19.1649L12.4997 19.1667ZM12.4998 14.1667H27.4998C27.9601 14.1667 28.3332 14.5398 28.3332 15.0001C28.3332 15.4274 28.0115 15.7797 27.597 15.8278L27.4998 15.8334H12.4998C12.0396 15.8334 11.6665 15.4603 11.6665 15.0001C11.6665 14.5727 11.9882 14.2205 12.4027 14.1724L12.4998 14.1667H27.4998H12.4998Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBtn);
export default __webpack_public_path__ + "static/media/menu-btn.bbfdd2891eef50afeff810eb8d711083.svg";
export { ForwardRef as ReactComponent };